import { connect } from 'react-redux';
import { openAlert } from '../../reducers/alert.reducers';
import { actionOnOrdercard, addOrderToRoute, openRouteDialog, removeOrderFromRoute, selectOrderForDeliveryInfo, startPrintOrder, setNewOrderAlertVisible } from '../../reducers/order.reducers';
import NewOrderDialog from './new-order-dialog';

const mapStateToProps = state => ({
  open: !!state.orders.newOrderAlertOpen,
  orders: state.orders.newOrderQueue,
  localSettings: state.app.localSettings,
  showTotalPrice: state.app.options && !!state.app.options.showTotalOrderPriceOnWaiterUI,
  printingorders: state.orders.printingorders,
  isRoutePlanning: state.orders.routeplanning,
  routestops: state.orders.routestops,
});

const mapDispatchToProps = dispatch => ({
  onDismiss: () => dispatch(setNewOrderAlertVisible(false)),
  proceedOrder: (order, description) => { dispatch(actionOnOrdercard({ order: order, proceeded: true, description: description })) },
  declineOrder: order => dispatch(openAlert({
    title: 'Wirklich ablehnen?',
    message: 'Wollen sie diese Bestellung wirklich ablehnen?',
    onAgreeAction:
      actionOnOrdercard({ order: order, proceeded: false, description: "Ablehnen" }),
    onDismissAction: null,
    isOrderDeclineAlert: true,
  })),
  openDeliveryDialog: order => dispatch(selectOrderForDeliveryInfo(order)),
  printOrder: order => dispatch(startPrintOrder(order)),
  addOrderToRoute: order => dispatch(addOrderToRoute(order)),
  removeOrderFromRoute: order => dispatch(removeOrderFromRoute(order)),
  openRouteDialog: () => dispatch(openRouteDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewOrderDialog);
